import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import {SetComponentId} from '../../redux/counterSlice'
import { SlTab, SlTabGroup, SlTabPanel } from '@shoelace-style/shoelace/dist/react'
import MyContacts from './MyContacts';
import B2BContacts from './B2BContacts';

function SalesContacts() {
    const dispatch = useDispatch()
    dispatch(SetComponentId(42))
  const [activeTab, setActiveTab] = useState('myContacts')
  const handleTabActivate = (event) => {
    setActiveTab(event.detail.name)
  }
  return (
    <>
      <h3>Contact Management</h3>
      <SlTabGroup onSlTabShow={handleTabActivate}>
        <SlTab slot="nav" panel="myContacts">
          My Contacts
        </SlTab>
        <SlTab slot="nav" panel="b2bContacs">
          B2B Contacts
        </SlTab>

        <SlTabPanel name="myContacts">{activeTab === 'myContacts' && <MyContacts />}</SlTabPanel>
        <SlTabPanel name="b2bContacs">{activeTab === 'b2bContacs' && <B2BContacts />}</SlTabPanel>
      </SlTabGroup>
    </>
  )
}

export default SalesContacts